import { c as _c } from "react/compiler-runtime";
import { Tag } from '@onefootprint/ui';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import type { VaultProxyOption } from '../../../../../hooks/use-vault-proxy-options';
import { VaultProxyOptionKind } from '../../../../../hooks/use-vault-proxy-options';
export type VaultProxyOptionProps<T extends React.ElementType> = {
  options: VaultProxyOption[];
  as?: T;
};
const VaultProxyOptions = t0 => {
  const $ = _c(21);
  const {
    options,
    as
  } = t0;
  const {
    t
  } = useTranslation("roles");
  const Component = as || Tag;
  if (options.length === 1) {
    if (options[0] === VaultProxyOptionKind.all) {
      let t1;
      if ($[0] !== t) {
        t1 = t(_temp);
        $[0] = t;
        $[1] = t1;
      } else {
        t1 = $[1];
      }
      let t2;
      if ($[2] !== Component || $[3] !== t1) {
        t2 = <Component>{t1}</Component>;
        $[2] = Component;
        $[3] = t1;
        $[4] = t2;
      } else {
        t2 = $[4];
      }
      return t2;
    }
    if (options[0] === VaultProxyOptionKind.jit) {
      let t1;
      if ($[5] !== t) {
        t1 = t(_temp2);
        $[5] = t;
        $[6] = t1;
      } else {
        t1 = $[6];
      }
      let t2;
      if ($[7] !== Component || $[8] !== t1) {
        t2 = <Component>{t1}</Component>;
        $[7] = Component;
        $[8] = t1;
        $[9] = t2;
      } else {
        t2 = $[9];
      }
      return t2;
    }
    let t1;
    if ($[10] !== t) {
      t1 = t(_temp3);
      $[10] = t;
      $[11] = t1;
    } else {
      t1 = $[11];
    }
    let t2;
    if ($[12] !== Component || $[13] !== t1) {
      t2 = <Component>{t1}</Component>;
      $[12] = Component;
      $[13] = t1;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    return t2;
  }
  if (options.length > 1) {
    let t1;
    if ($[15] !== options.length || $[16] !== t) {
      t1 = t(_temp4, {
        count: options.length
      });
      $[15] = options.length;
      $[16] = t;
      $[17] = t1;
    } else {
      t1 = $[17];
    }
    let t2;
    if ($[18] !== Component || $[19] !== t1) {
      t2 = <Component>{t1}</Component>;
      $[18] = Component;
      $[19] = t1;
      $[20] = t2;
    } else {
      t2 = $[20];
    }
    return t2;
  }
  return null;
};
export default VaultProxyOptions;
function _temp($) {
  return $.scopes.invoke_vault_proxy.all;
}
function _temp2($_0) {
  return $_0.scopes.invoke_vault_proxy.jit;
}
function _temp3($_1) {
  return $_1.scopes.invoke_vault_proxy.one;
}
function _temp4($_2) {
  return $_2.scopes.invoke_vault_proxy.other;
}